import script from "./AllWorkspaces.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllWorkspaces.vue?vue&type=script&lang=ts&setup=true"

import "./AllWorkspaces.vue?vue&type=style&index=0&id=f518f404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f518f404"]])

export default __exports__